"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPunchesByEligibility = void 0;
const lodash_1 = require("lodash");
const SelectPunchTypes_1 = require("./SelectPunchTypes");
const PunchWorkflowTypes_1 = require("../../PunchWorkflowTypes");
const PunchModalTypes_1 = require("../../../../components/PunchModal/PunchModalTypes");
const processPunchesByEligibility = (selectedPunchList, action, editPunchLockoutStatus) => {
    const eligiblePunches = [];
    const ineligiblePunches = [];
    const punchIsEligible = (punch) => {
        switch (action) {
            case PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT: {
                return ([PunchModalTypes_1.LockoutStatusType.OK, PunchModalTypes_1.LockoutStatusType.WARNING].includes(editPunchLockoutStatus) &&
                    !punch.isInProgress &&
                    punch.eligibility.editEligibility);
            }
            case PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.DELETE: {
                return (!punch.isInProgress &&
                    (punch.eligibility.deleteEligibility ||
                        punch.eligibility.deleteAIPEligibility));
            }
            default:
                return false;
        }
    };
    for (const { startSpan, endSpan } of selectedPunchList) {
        if (startSpan === null || startSpan === void 0 ? void 0 : startSpan.punchId) {
            const spanWithInMarker = Object.assign(Object.assign({}, (0, lodash_1.cloneDeep)(startSpan)), { punchType: SelectPunchTypes_1.PunchType.In });
            if (punchIsEligible(startSpan)) {
                eligiblePunches.push(spanWithInMarker);
            }
            else {
                ineligiblePunches.push(spanWithInMarker);
            }
        }
        if (endSpan === null || endSpan === void 0 ? void 0 : endSpan.punchId) {
            const spanWithOutMarker = Object.assign(Object.assign({}, (0, lodash_1.cloneDeep)(endSpan)), { punchType: SelectPunchTypes_1.PunchType.Out });
            if (punchIsEligible(endSpan)) {
                eligiblePunches.push(spanWithOutMarker);
            }
            else {
                ineligiblePunches.push(spanWithOutMarker);
            }
        }
    }
    return [eligiblePunches, ineligiblePunches];
};
exports.processPunchesByEligibility = processPunchesByEligibility;
